import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, first, map } from 'rxjs';
import { selectSelectedCompany } from 'src/app/auth/store/auth.selectors';
import { CompanyDataType } from 'src/app/auth/utility/auth.models';
import { onUntouched } from '../loading-state/loadable';
import { getSubscription } from './store/subscription.actions';
import { selectSubscription } from './store/subscription.selectors';
import { PENDING_SUBSCRIPTION_STATES } from './subscription.models';

export const subscriptionGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  // Check if the account has an active subscription
  return combineLatest([
    store.select(selectSubscription),
    store.select(selectSelectedCompany),
  ]).pipe(
    filter(([, company]) => !!company),
    onUntouched(() => store.dispatch(getSubscription()), 0),
    first(([subscription]) => subscription.value !== undefined),
    map(([subscription, company]) => {
      const error = subscription.error;
      const value = subscription.value;

      if (!value && error) {
        if (error instanceof HttpErrorResponse)
          return router.createUrlTree(['error', error.status]);

        return router.createUrlTree(['error']);
      }

      // CONSUMER accounts
      if (company!.data_type === CompanyDataType.IN) return true;
      // if (company.data_type === CompanyDataType.IN) {
      //   if (!value || value.state in PENDING_SUBSCRIPTION_STATES) {
      //     // console.warn('Redirecting to select subscription page.');
      //     return router.createUrlTree(['auth', 'select-subscription']);
      //   }
      //   if (value.isFree) {
      //     // console.warn('Redirecting to get full access page.');
      //     return router.createUrlTree(['auth', 'get-full-access']);
      //   }
      //   return true;
      // }

      // COMMERCIAL accounts
      if (!value || value.state in PENDING_SUBSCRIPTION_STATES)
        return router.createUrlTree(['auth', 'subscribe']);

      return true;
    })
  );
};
